module.exports = __webpack_public_path__ + "img/icon-7.e7d07ebb.svg";